import { VStack, HStack, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const MissionVisionSection = () => {
	const { t } = useTranslation();

	return (
		<HStack className="w-full gap-[28px] flex-col md:flex-row items-stretch">
			{/* 미션 */}
			<motion.div
				className="flex-1 w-full flex"
				initial={{ opacity: 0, x: -50 }}
				whileInView={{ opacity: 1, x: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.6 }}
			>
				<VStack className="gap-[20px] p-[40px] rounded-[20px] bg-gradient-to-br from-pm-strong to-[#FF8C5A] h-full items-start">
					<div className="flex items-center justify-center w-[48px] h-[48px] rounded-[10px] bg-white/20">
						<Icon name="Action" width={28} height={28} className="text-ct-elevated" />
					</div>
					<VStack className="gap-[12px] items-start">
						<h3 className="text-2xl text-ct-elevated font-semibold">
							{t("company.missionVision.missionTitle")}
						</h3>
						<p className="text-lg text-ct-elevated font-medium leading-relaxed">
							{t("company.missionVision.mission")}
						</p>
					</VStack>
				</VStack>
			</motion.div>

			{/* 비전 */}
			<motion.div
				className="flex-1 w-full flex"
				initial={{ opacity: 0, x: 50 }}
				whileInView={{ opacity: 1, x: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.6 }}
			>
				<VStack className="gap-[20px] p-[40px] rounded-[20px] bg-bg-regular h-full items-start border-2 border-pm-strong">
					<div className="flex items-center justify-center w-[48px] h-[48px] rounded-[10px] bg-pm-strong/10">
						<Icon name="Gyul" width={28} height={28} className="text-pm-strong" />
					</div>
					<VStack className="gap-[12px] items-start">
						<h3 className="text-2xl text-ct-strong font-semibold">
							{t("company.missionVision.visionTitle")}
						</h3>
						<p className="text-lg text-ct-regular font-medium leading-relaxed">
							{t("company.missionVision.vision")}
						</p>
					</VStack>
				</VStack>
			</motion.div>
		</HStack>
	);
};
